import { render, staticRenderFns } from "./Proxies.vue?vue&type=template&id=79d00837&scoped=true&"
import script from "./Proxies.vue?vue&type=script&lang=js&"
export * from "./Proxies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d00837",
  null
  
)

export default component.exports